module.exports = __webpack_public_path__ + "static/5-606a8ea696abe3113f42deb2d0b0bfb3.png";